module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.editing) ? _c('span', {
    staticClass: "editable-label",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("\n  " + _vm._s(_vm.valueFormatted) + "\n  "), _c('i', {
    staticClass: "fa fa-edit"
  })]) : _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-7@md"
  }, [(Object.keys(_vm.moneyTypes).indexOf(_vm.type) !== -1) ? _c('money', _vm._b({
    ref: "input",
    staticClass: "form-input",
    model: {
      value: (_vm.newValue),
      callback: function($$v) {
        _vm.newValue = $$v
      },
      expression: "newValue"
    }
  }, 'money', _vm.moneyTypes[_vm.type], false)) : ((_vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    ref: "input",
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newValue) ? _vm._i(_vm.newValue, null) > -1 : (_vm.newValue)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.newValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newValue = $$c
        }
      }, function($event) {
        return _vm.onChangeAttribute()
      }]
    }
  }) : ((_vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    ref: "input",
    staticClass: "form-input",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newValue, null)
    },
    on: {
      "change": [function($event) {
        _vm.newValue = null
      }, function($event) {
        return _vm.onChangeAttribute()
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    ref: "input",
    staticClass: "form-input",
    attrs: {
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "change": function($event) {
        return _vm.onChangeAttribute()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-5@md no-pdd"
  }, [_c('button', {
    staticClass: "btn-action btn t-error btn--default no-pdd",
    on: {
      "click": _vm.cancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-action btn t-success btn--default no-pdd",
    on: {
      "click": _vm.confirm
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b27cec2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/Editable/Base.vue
// module id = 3406
// module chunks = 0